/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { get } from "lodash";
import ActionItem from "../ActionItem";
import Profile from "../Profile";
import useVendorUser from "../../hooks/use-vendor-user";

const StyledGlobalSide = styled.nav`
  ${({ theme, hideLg }) => theme.mq.xsOnly`
    ${() => {
      return hideLg ? "width:100%;" : "";
    }}
  `}
  ${({ gridSide }) => (gridSide ? "grid-area: sidebar;" : "")}
  position: fixed;
  height: 100vh;
  padding: 2rem 0 0;
  display: grid;
  top: 0;
  overflow-y: auto;
  ${({ gridSide }) => (gridSide ? "left:0;" : "right:0;")}
  transform: ${({ hideSide }) => {
    return hideSide ? "translate3d(100%, 0px, 0px)" : "";
  }};
  transition: transform 0.75s, width 0.5s ease 0s;
  z-index: 3;
  background-color: ${({ theme }) => theme.themeColors.lightGreen3};
  grid-template-rows: 1fr auto;
  display: ${({ hideSm }) => {
    return hideSm ? "none" : "grid";
  }};

  ${({ hideLg }) =>
    hideLg &&
    css`
      width: 375px;
      margin-left: auto;
      margin-top: 2rem;
    `}

  ${({ theme, hideLg }) => theme.mq.lg`
    height: 100vh;
    position: sticky;
    padding: 0;
    top: 0;
    transform: translate3d(0, 0px, 0px);
    width: 250px;
    ${() => {
      return hideLg ? "display:none;" : "display:grid;";
    }}
  `}
`;

const SideBarList = styled.ul`
  padding: 2rem 1.875rem;
  width: 100%;
`;

const BottomSideBarList = styled.ul`
  padding: 2rem 0;
  width: 100%;
`;

const LineDivide = styled.hr`
  opacity: 0.65;
  border: none;
  background-color: #cfcecd;
  height: 2px;
`;
// ************ COMMENTED OUT FOR POST MVP USE *****************
// const SideBarFooter = styled.div`
//   margin: 20px 30px;
// `;

// const SideBarFooterWrapper = styled.div`
//   width: 100%;
// `;

const ProfileCardWrapper = styled.div`
  ${({ theme }) => theme.mq.lg`
    display: none;
  `}
`;

const Spacer = styled.div`
  padding: 5px;
`;

const ActionItemWrapper = styled.li`
  margin: 15px 0;
  display: inline-block;
  width: 100%;
`;

const GlobalSideScrollableContainer = styled.div`
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  ${({ theme }) => theme.mq.lg`
  overflow-y: hidden;
`}
`;

const touchMoveHandler = (e) => {
  const sideNavId = document.getElementById("global-side");
  if (!sideNavId.contains(e.target)) {
    e.preventDefault();
  }
};

const GlobalSide = React.forwardRef((props, ref) => {
  const {
    hideSide,
    sideBarItems,
    // footerSupportItem,
    loginItems,
    profileItems,
    hideLg,
    hideSm,
    profileCardIdentity,
    gridSide,
    providerId,
    isCustomerNav,
    isProviderNav,
    isAdminNav,
  } = props;

  const vendorUser = useVendorUser();
  const businessName = get(vendorUser, "business.businessName", undefined);

  useEffect(() => {
    if (hideSide) {
      document.body.classList.remove("body-no-scroll");
      document.body.removeEventListener("touchmove", touchMoveHandler, {
        passive: false,
      });
    } else {
      document.body.classList.add("body-no-scroll");
      document.body.addEventListener("touchmove", touchMoveHandler, {
        passive: false,
      });
    }

    return () => {
      document.body.classList.remove("body-no-scroll");
      document.body.removeEventListener("touchmove", touchMoveHandler, {
        passive: false,
      });
    };
  }, [hideSide]);

  return (
    <StyledGlobalSide
      gridSide={gridSide}
      ref={ref}
      hideLg={hideLg}
      hideSm={hideSm}
      hideSide={hideSide}
      aria-label="secondary"
      id="global-side"
    >
      <GlobalSideScrollableContainer body-scroll-lock-ignore>
        <SideBarList>
          <ProfileCardWrapper>
            {loginItems.map((item) => {
              return (
                <ActionItemWrapper key={item.id}>
                  <ActionItem
                    defaultColor="#FF7817"
                    {...item}
                    providerId={providerId}
                  />
                </ActionItemWrapper>
              );
            })}
          </ProfileCardWrapper>
          {sideBarItems.map((item) => {
            return (
              <ActionItemWrapper key={item.id}>
                <ActionItem
                  defaultColor="#FF7817"
                  {...item}
                  providerId={providerId}
                />
              </ActionItemWrapper>
            );
          })}
        </SideBarList>

        <BottomSideBarList>
          {vendorUser &&
          vendorUser.id &&
          profileCardIdentity &&
          !isCustomerNav &&
          Object.entries(profileCardIdentity).length ? (
            <ProfileCardWrapper>
              <LineDivide />
              <Spacer />
              <Profile
                profileCardIdentity={profileCardIdentity}
                profileItems={profileItems}
                hideLgSidebarProvider
                isCustomerNav={isCustomerNav}
                businessName={businessName}
              />
              {/* {footerSupportItem ? <LineDivide /> : null} */}
              <Spacer />
            </ProfileCardWrapper>
          ) : null}
          {profileCardIdentity &&
          Object.entries(profileCardIdentity).length &&
          isCustomerNav ? (
            <ProfileCardWrapper>
              <LineDivide />
              <Spacer />
              <Profile
                profileCardIdentity={profileCardIdentity}
                profileItems={profileItems}
                hideLgSidebarProvider
                isCustomerNav={isCustomerNav}
                isAdminNav={isAdminNav}
                isProviderNav={isProviderNav}
              />
              {/* {footerSupportItem ? <LineDivide /> : null} */}
            </ProfileCardWrapper>
          ) : null}
        </BottomSideBarList>
        {/* ************ COMMENTED OUT FOR POST MVP USE ***************** */}
        {/* <SideBarFooterWrapper>
        {footerSupportItem ? (
          <SideBarFooter>
            <ActionItem {...footerSupportItem} providerId={providerId} />
          </SideBarFooter>
        ) : null}
      </SideBarFooterWrapper> */}
      </GlobalSideScrollableContainer>
    </StyledGlobalSide>
  );
});

GlobalSide.propTypes = {
  hideSide: PropTypes.bool,
  sideBarItems: PropTypes.arrayOf(PropTypes.object),
  // footerSupportItem: PropTypes.shape({}),
  gridSide: PropTypes.bool,
  profileItems: PropTypes.arrayOf(PropTypes.object),
  hideLg: PropTypes.bool,
  hideSm: PropTypes.bool,
  loginItems: PropTypes.arrayOf(PropTypes.object),
  profileCardIdentity: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
  }),
  providerId: PropTypes.string,
  isCustomerNav: PropTypes.bool,
};

GlobalSide.defaultProps = {
  hideSide: true,
  gridSide: false,
  sideBarItems: [],
  // footerSupportItem: null,
  profileItems: [],
  hideLg: false,
  hideSm: false,
  loginItems: [],
  profileCardIdentity: {},
  providerId: undefined,
  isCustomerNav: false,
};

export default GlobalSide;
